module.exports = __webpack_public_path__ + "static/img/96-2.63701d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/96-2.jpg
// module id = 5r9I
// module chunks = 0